<template lang="html">
  <label
    :class="['container', 'ms-checkbox', {'ms-checkbox--disabled': disabled}]"
    :tabindex="tabindex"
    @keydown.tab="onTab"
    @keydown.enter="onEnter"
  >
    <input
      v-bind="$attrs"
      type="checkbox"
      class="ms-checkbox--input"
      :value="valueX"
      :disabled="disabled"
      v-on="listeners"
    >
    <!-- NVHIEU 17/12/2020 Sửa hiển thị checked -->
    <span
      :class="[
        valueX ? 'icon-square-check-primary' : 'icon-square-uncheck',
        'checkmark',
        setDisabled
      ]"
    />
    <span class="con-slot-label">
      <slot />
    </span>
  </label>
</template>

<script>
import _color from "../color";
export default {
  name: "MsCheckbox",
  inheritAttrs: false,
  inheritAttrs: false,
  props: {
    color: {
      default: "primary",
      type: String,
    },
    tabindex: {
      type: Number,
      default: 1,
    },
    tabTrigger: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {},
    selectedID: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      valueX: this.value,
    };
  },
  computed: {
    // set class làm mờ radio
    setDisabled() {
      if (this.disabled) {
        return "disabled";
      } else {
        return "";
      }
    },
    listeners() {
      return {
        change: (evt) => {
          this.toggleValue(evt);
        },
      };
    },
  },
  watch: {
    /**
    Gán lại data khi props thay đổi
    created by pdthien
     */
    value(val) {
      this.valueX = val;
    },
  },
  methods: {
    onTab(e) {
      this.tabTrigger && this.$emit("input", true);
    },
    toggleValue(evt) {
      if (!this.disabled) {
        this.valueX = !this.valueX;
        this.$emit("input", this.valueX);
        this.$emit("changed", this.valueX);
        this.selectedID && this.$emit("selectID", this.selectedID, this.valueX);
      }
    },

    onEnter() {
      event.stopPropagation();
      this.toggleValue();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/controls/msCheckbox.scss";
label {
  text-align: left !important;
  display: flex !important;
  align-items: center !important;
}
.disabled {
  opacity: 0.5 !important;
}

.ms-checkbox--disabled {
  cursor: default;
  opacity: 0.8;
}

.ms-checkbox .checkmark {
  top: 0;
}

.ms-checkbox .ms-checkbox--input {
  height: inherit;
}

.ms-checkbox:hover .icon-square-uncheck {
  background-color: #13b2d8 !important;
}

.ms-checkbox--disabled:hover .icon-square-uncheck {
  background-color: #686c7b !important;
}

.con-slot-label {
  text-overflow: ellipsis !important;
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  //overflow: hidden !important;
  //-webkit-line-clamp: 1 !important;
}
</style>
